module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/casestudy-avatar-04-d14a1d050d9c7762d647bd6af8db75f3.png";